import Overlay from './src/overlay'

export const ZOverlay = Overlay
export default ZOverlay

export * from './src/overlay'
